import { render, staticRenderFns } from "./PayoutSettings.vue?vue&type=template&id=6b903002"
import script from "./PayoutSettings.vue?vue&type=script&lang=js"
export * from "./PayoutSettings.vue?vue&type=script&lang=js"
import style0 from "./PayoutSettings.vue?vue&type=style&index=0&id=6b903002&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports